import formatDate from "@/client/helpers/formatDate";

export default {
  methods: { formatDate },
};
